var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilmSlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.5H20.25V18.75C20.25 18.9489 20.171 19.1397 20.0303 19.2803C19.8897 19.421 19.6989 19.5 19.5 19.5H4.5C4.30109 19.5 4.11032 19.421 3.96967 19.2803C3.82902 19.1397 3.75 18.9489 3.75 18.75V10.5Z",
    stroke: "#6D798C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74999 10.4999L19.6875 6.22493L18.9094 3.32805C18.8844 3.23271 18.8407 3.14331 18.7808 3.06508C18.7208 2.98686 18.6459 2.92138 18.5603 2.87248C18.4748 2.82359 18.3803 2.79227 18.2825 2.78034C18.1846 2.76842 18.0854 2.77614 17.9906 2.80305L3.50624 6.6843C3.41072 6.70936 3.32109 6.75303 3.24249 6.81281C3.16389 6.8726 3.09787 6.94732 3.04822 7.03268C2.99857 7.11804 2.96627 7.21237 2.95316 7.31025C2.94006 7.40813 2.94642 7.50763 2.97187 7.60305L3.74999 10.4999Z",
    stroke: "#6D798C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1969 4.3501L16.7907 7.00322",
    stroke: "#6D798C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68127 6.10303L10.2656 8.75615",
    stroke: "#6D798C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmSlate);
export default __webpack_public_path__ + "static/media/FilmSlate.362aa50fddf5835c928dc2fe3e60e577.svg";
export { ForwardRef as ReactComponent };